<template>
  <v-runtime-template :template="gridItem"></v-runtime-template>
</template>

<script>
import { mapState } from 'vuex'
import { Hits } from '@mezereon/ui-components-vue'
import VRuntimeTemplate from 'v-runtime-template'

export default {
  components: {
    VRuntimeTemplate
  },
  mixins: [Hits],
  props: {
    item: {
      type: Object,
      required: true
    },
    score: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState('search', ['gridItem'])
  }
}
</script>
